const MODALITIES = [
  {
    tag: '01 — Staff Augmentation',
    title: 'Talento experto integrado a tu equipo',
    tagline: '"Plug-in de talento senior a la velocidad que pidas."',
    desc: 'El talento que necesitas se adapta a tu equipo para liderar tus proyectos sin inconvenientes.',
    steps: ['Reunión\ninicial', 'Gestión\nproyectos', 'Selección\nde perfiles', 'Ejecución'],
    metric: 'Cobertura promedio en 7 – 15 días',
  },
  {
    tag: '02 — Equipos Manejados',
    title: 'Equipo completo gestionado por eTribe',
    tagline: '"Tú decides el qué, nosotros nos encargamos del cómo."',
    desc: 'Disfruta los beneficios del know-how de profesionales altamente calificados sin distraerte de tu negocio principal.',
    steps: ['Reunión\ninicial', 'Estimación\ny perfiles', 'Ejecución', 'Relación\ncontinua'],
  },
  {
    tag: '03 — Basado en Proyectos',
    title: 'Proyecto cerrado de principio a fin',
    tagline: '"Alcance acordado, resultado garantizado."',
    desc: 'Gestionamos tu proyecto end-to-end en base a un alcance acordado, con los mejores talentos de la industria.',
    steps: ['Reunión\ninicial', 'Estimación\nproyecto', 'Ejecución', 'Servicios\nmanejados'],
  },
];

export default function Modalities() {
  return (
    <section id="modalidades" className="py-[120px]">
      <div className="container-etribe">
        <div className="max-w-[720px] mb-16">
          <p className="eyebrow"><span>Flexibilidad</span></p>
          <h2 className="text-[clamp(32px,3.6vw,48px)] mb-4">Cómo trabajamos contigo</h2>
          <p className="text-[clamp(17px,1.3vw,20px)] text-etribe-ink-2 leading-[1.55]">
            Tres modalidades de entrega para adaptarnos a la forma en que tu organización necesita avanzar.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {MODALITIES.map((m) => (
            <article
              key={m.tag}
              className="bg-white border border-etribe-line rounded-[14px] p-10 flex flex-col hover:-translate-y-1 hover:shadow-card transition-all duration-300"
            >
              <span className="text-etribe-gray-500 text-[13px] tracking-[0.12em] uppercase font-semibold mb-3">
                {m.tag}
              </span>
              <h3 className="text-[22px] mb-3.5">{m.title}</h3>
              <p className="italic text-etribe-blue font-medium mb-3.5 text-[15px]">{m.tagline}</p>
              <p className="text-etribe-ink-2 text-sm mb-7">{m.desc}</p>

              <div className="mt-auto border-t border-etribe-line pt-6">
                <div className="flex items-center justify-between mb-5">
                  <p className="text-[11px] tracking-[0.14em] uppercase text-etribe-gray-500 font-semibold">Proceso</p>
                  <span className="text-[11px] tracking-[0.04em] text-etribe-gray-500 font-medium">
                    {m.steps.length} pasos
                  </span>
                </div>
                <ol className="relative space-y-3.5">
                  <span
                    aria-hidden
                    className="absolute left-[13px] top-2 bottom-2 w-px bg-gradient-to-b from-etribe-blue/30 via-etribe-line to-etribe-line"
                  />
                  {m.steps.map((step, i) => {
                    const isLast = i === m.steps.length - 1;
                    return (
                      <li key={i} className="relative flex items-center gap-3.5">
                        <span
                          className={[
                            'relative z-10 w-[26px] h-[26px] rounded-full grid place-items-center flex-shrink-0 font-heading text-[11px] tracking-[0.02em] transition-colors',
                            isLast
                              ? 'bg-etribe-yellow text-etribe-blue ring-4 ring-etribe-yellow/15'
                              : 'bg-etribe-blue text-white',
                          ].join(' ')}
                        >
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        <span className="text-[13.5px] font-medium text-etribe-ink leading-snug">
                          {step.replace('\n', ' ')}
                        </span>
                      </li>
                    );
                  })}
                </ol>
              </div>

              {m.metric && (
                <div className="mt-5 inline-flex items-center gap-2.5 px-4 py-3 bg-etribe-yellow/15 border border-etribe-yellow/40 rounded-md text-[13px] font-semibold text-etribe-blue self-stretch">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 2" />
                  </svg>
                  <span>{m.metric}</span>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
